import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ScheduleModal.scss';

const ScheduleModal = ({
  showScheduleModal,
  toggleScheduleModal,
  schedule,
  currentSchedule,
  getAdjustedTime,
  getSessionIcons,
  formatDuration,
}) => {
  if (!showScheduleModal) return null;

  return (
    <div className="schedule-modal">
      <div className="schedule-modal-content">
        <button className="modal-close-btn" onClick={toggleScheduleModal} aria-label="Close modal">
          ×
        </button>
        <h2>Event Schedule</h2>
        <div className="schedule-list">
          {schedule.map((item, index) => {
            const eventDate = new Date(item.date);
            const today = new Date();
            const isToday = eventDate.toDateString() === today.toDateString();
            const isTomorrow =
              eventDate.toDateString() === new Date(today.getTime() + 24 * 60 * 60 * 1000).toDateString();

            let dateLabel = '';
            if (isToday) {
              dateLabel = 'Today';
            } else if (isTomorrow) {
              dateLabel = 'Tomorrow';
            } else {
              dateLabel = eventDate.toLocaleDateString([], {
                weekday: 'short',
                month: 'short',
                day: 'numeric',
              });
            }

            return (
              <div key={index} className={`schedule-item ${currentSchedule === item ? 'current' : ''}`}>
                <span className="time">
                  {getAdjustedTime(item.time, item.date).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                  <span className="date-label">{dateLabel}</span>
                </span>
                <span className="presenter">
                  {typeof getSessionIcons(item).presenterIcon === 'string' ? (
                    <span className="emoji-icon">{getSessionIcons(item).presenterIcon}</span>
                  ) : (
                    <FontAwesomeIcon icon={getSessionIcons(item).presenterIcon} />
                  )}
                  {item.presenter}
                  {item.location && <span className="location">📍 {item.location}</span>}
                </span>
                <span className="category">
                  {typeof getSessionIcons(item).categoryIcon === 'string' ? (
                    <span className="emoji-icon">{getSessionIcons(item).categoryIcon}</span>
                  ) : (
                    <FontAwesomeIcon icon={getSessionIcons(item).categoryIcon} />
                  )}
                  {item.category}
                </span>
                <span className="duration">
                  {item.discussion
                    ? `${formatDuration(item.duration - item.discussion)}+${item.discussion}`
                    : formatDuration(item.duration)}
                </span>
              </div>
            );
          })}
        </div>
        <button className="close-modal" onClick={toggleScheduleModal}>
          Close
        </button>
      </div>
    </div>
  );
};

export default ScheduleModal;
